"use client";
import { Configure, InstantSearch } from "react-instantsearch";
import { SearchContextProvider } from "@/components/Search/components/SearchContextProvider";
import getPublicClient from "@/lib/algolia/getPublicClient";
import { PRODUCT_SUMMARY_INDEX_EN } from "@/constants/algolia";
import { getFacetFiltersValue } from "@/components/Search/utils/getFacetFiltersValue";

import {
  DEFAULT_SEARCH_CONFIG,
  QUERY_URL_PARAM,
  RESULT_PRODUCT_TYPE_MAP,
} from "@/components/Search/constants";
import getFilters from "@/components/Search/utils/getFilters";
import { getMappedSearchParams } from "@/components/Search/utils/mapFacetParams";
import { ReactNode } from "react";
import useSearchInitialState from "@/components/Search/hooks/useSearchInitialState";
import getResultTypeFromUrl from "../Search/utils/getResultTypeFromUrl";
import { ReadonlyURLSearchParams } from "next/navigation";
import { ConfigureProps } from "react-instantsearch";

const searchClient = getPublicClient();

export interface HighlightsSearchWrapperProps {
  searchQuery?: string;
  children?: ReactNode;
  numberOfHits?: number;
}

export function HighlightsSearchWrapper({
  searchQuery,
  children,
}: HighlightsSearchWrapperProps) {
  const indexName = PRODUCT_SUMMARY_INDEX_EN as string;

  const searchParams = new URLSearchParams(searchQuery);
  const query = searchParams.get(QUERY_URL_PARAM);
  const { paramsArray } = getMappedSearchParams(searchParams, indexName);
  const pageTab =
    RESULT_PRODUCT_TYPE_MAP[
      getResultTypeFromUrl(searchParams as unknown as ReadonlyURLSearchParams)
    ];
  const initialSearchState = useSearchInitialState(indexName);

  const configForSearch: ConfigureProps = {
    ...DEFAULT_SEARCH_CONFIG,
    filters: getFilters({ indexName }),
    query: query || "",
    facetFilters: getFacetFiltersValue({ indexName, paramsArray }),
  };

  if (pageTab) {
    configForSearch.facetsRefinements = { product: [pageTab] };
  }

  return (
    <div>
      <SearchContextProvider searchIndex={indexName}>
        <InstantSearch
          searchClient={searchClient}
          indexName={indexName}
          initialUiState={initialSearchState}
          future={{ preserveSharedStateOnUnmount: true }}
        >
          <Configure {...configForSearch} />
          {children}
        </InstantSearch>
      </SearchContextProvider>
    </div>
  );
}
